/* eslint-disable no-nested-ternary */
import React, { useRef, useState, useEffect } from "react";
import clsx from "clsx";
import styled from "styled-components";
import { FormProvider, useForm } from "react-hook-form";
import { borderRadius, colors, responsive, space } from "utils/theme";
import { columns } from "./columns";
import { CourseFilterForm } from "./components";

const BLACK_LIST_TEACHERS = ["محمد هفت جواهریان"]; // Exact match checking
function TimeTableCMP({ className, data = [] }) {
  const [dataToShow, setDataToShow] = useState([...data]);

  useEffect(() => {
    setDataToShow([...data]);
  }, [data]);

  // Printer
  const componentRef = useRef(null);
  const { control } = useForm();
  return (
    <div className={className} ref={componentRef}>
      <br />
      <FormProvider control={control}>
        <CourseFilterForm coursesData={data} setFormatted={setDataToShow} />
      </FormProvider>
      <br />
      {dataToShow.map?.((item, i) => {
        return item?.map?.((oriItem, oriKey) => {
          return (
            <React.Fragment key={String(i) + String(oriKey)}>
              <p className={clsx("part-title", oriKey === 0 && "first")}>
                {oriItem?.title ? `${oriItem?.type}: ${oriItem?.title}` : "-"}
                {oriItem.title && oriItem.segmentAndSegmentType ? " - " : ""}
                {oriItem.segmentAndSegmentType
                  ? `مقطع: ${oriItem.segmentAndSegmentType}`
                  : ""}
              </p>
              <div className="table-container">
                <table className="tw-min-w-[1200px] md:tw-min-w-[unset]">
                  <thead>
                    <tr>
                      {columns.map((v, k) => (
                        <th key={`${k + 1}`} style={v.style ?? {}}>
                          {v?.title ?? "-"}
                        </th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {oriItem.planningList?.map((plan) =>
                      plan.courses?.length === 0 ? null : (
                        <React.Fragment key={plan.title}>
                          <tr className="section-title">
                            <td colSpan="10000">{plan.title ?? "-"}</td>
                          </tr>
                          {plan.courses?.map((v, courseKey) => (
                            <tr key={v.id}>
                              {columns.map((vd, kd) => (
                                <td key={`${kd + 1}`}>
                                  {vd.key === "#id"
                                    ? courseKey + 1
                                    : vd.render
                                    ? vd.render(v)
                                    : vd.key === "professor"
                                    ? v?.professor &&
                                      !BLACK_LIST_TEACHERS.includes(v.professor)
                                      ? v.professor
                                      : "-"
                                    : v[vd.key]}
                                </td>
                              ))}
                            </tr>
                          ))}
                        </React.Fragment>
                      )
                    )}
                  </tbody>
                </table>
              </div>
            </React.Fragment>
          );
        });
      })}
      {/* <Printer componentRef={componentRef} /> */}
    </div>
  );
}

const TimeTable = styled(TimeTableCMP)`
  @media print {
    padding: ${space(4)};
    border: 1px solid black;
    margin: ${space(2)};
    width: calc(100% - ${space(4)});
    .hide-on-print {
      display: none;
    }
  }

  .part-title {
    @media (min-width: ${responsive.md}) {
      font-size: 13px;
    }
    @media (min-width: ${responsive.xxxl}) {
      font-size: 17.33px;
    }
    background: ${colors.primary.main};
    color: white;
    padding: ${space(2)};
    text-align: center;
    &.first {
      border-top-left-radius: ${borderRadius.normal};
      border-top-right-radius: ${borderRadius.normal};
    }
  }
  .table-container {
    overflow: auto;
  }
  table {
    width: 100%;
    text-align: center;
    border-spacing: 0;
    th {
      font-size: 0.9rem;
      font-weight: 500;
      padding-top: ${space(1.5)};
      padding-bottom: ${space(1.5)};
      border-left: 1px solid ${colors.primary.lighter};
      &:first-child {
        border-right: 1px solid ${colors.primary.lighter};
      }
    }
    td {
      font-size: 1rem;
      @media (min-width: ${responsive.xxxl}) {
        font-size: 17.33px;
      }
      font-weight: 300;
      padding-top: ${space(1)};
      padding-bottom: ${space(1)};
      border-left: 1px solid ${colors.primary.lighter};
      /* border-top: 1px solid ${colors.primary.lighter}; */
      &:first-child {
        border-right: 1px solid ${colors.primary.lighter};
      }
    }
    tr {
      &:nth-child(odd) {
        td {
          background: ${colors.primary.lightest};
        }
      }
      &:last-child {
        td {
          border-bottom: 1px solid ${colors.primary.lighter};
        }
      }
      &.section-title {
        td {
          background: ${colors.grey[7]};
          font-weight: 500;
          font-size: 0.9rem;
        }
      }
    }
  }
`;

export default TimeTable;
